import { useMutation } from "react-query";

import { Endpoints } from "../../enums/Endpoints";
import { QueryParams } from "../../enums/QueryParams";

import { smartposUrl } from "../ApiClient";
import { IGetAllProductsPayload } from "@amzn/rangoli-seller-desktop-utils/src/index";

const { GET_ALL_PRODUCTS_KEY } = QueryParams;
const { GET_ALL_PRODUCTS } = Endpoints;

const getAllProducts = async (payload: IGetAllProductsPayload) => {
  const response = (
    await smartposUrl.post(GET_ALL_PRODUCTS, payload, {
      withCredentials: false,
    })
  )?.data;
  return response;
};

export const useGetAllProductsMutation = () => {
  const getAllProductsMutation = useMutation({
    mutationKey: [GET_ALL_PRODUCTS_KEY],
    mutationFn: getAllProducts,
  });

  return getAllProductsMutation;
};

